<template>
  <div class="footer-management">
    <div class="toolbar">
      <el-button type="primary" @click="addLink">添加链接</el-button>
      <el-button type="primary" @click="saveConfig">保存配置</el-button>
    </div>

    <el-card>
      <el-form :model="form" label-width="120px">
        <el-form-item label="版权信息">
          <el-input v-model="form.copyright_text" />
        </el-form-item>
        <el-form-item label="链接列表">
          <div v-for="(link, index) in form.links" :key="index" class="link-item">
            <el-input v-model="link.text" placeholder="链接文本" style="width: 200px; margin-right: 10px;" />
            <el-input v-model="link.url" placeholder="链接地址" style="width: 300px; margin-right: 10px;" />
            <el-button size="small" type="danger" @click="removeLink(index)">删除</el-button>
          </div>
          <div v-if="form.links.length === 0" style="color: rgba(255, 255, 255, 0.5); padding: 20px; text-align: center;">
            暂无链接，点击上方"添加链接"按钮添加
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'FooterManagement',
  data() {
    return {
      form: {
        copyright_text: '© 2024 MKCases. All rights reserved.',
        links: []
      },
      configId: null
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      try {
        const response = await api.get('/admin/about/footer/')
        let config = null
        if (Array.isArray(response.data)) {
          config = response.data.length > 0 ? response.data[0] : null
        } else if (response.data.results && Array.isArray(response.data.results)) {
          config = response.data.results.length > 0 ? response.data.results[0] : null
        } else {
          config = response.data
        }
        
        if (config) {
          this.configId = config.id
          this.form = {
            copyright_text: config.copyright_text || '© 2024 MKCases. All rights reserved.',
            links: config.links || []
          }
        }
      } catch (error) {
        console.error('加载配置失败:', error)
      }
    },
    addLink() {
      this.form.links.push({ text: '', url: '' })
    },
    removeLink(index) {
      this.form.links.splice(index, 1)
    },
    async saveConfig() {
      try {
        if (this.configId) {
          await api.patch(`/admin/about/footer/${this.configId}/`, this.form)
        } else {
          await api.post('/admin/about/footer/', this.form)
        }
        this.$message.success('保存成功')
        this.loadConfig()
      } catch (error) {
        this.$message.error('保存失败')
      }
    }
  }
}
</script>

<style scoped>
.footer-management {
  width: 100%;
}

.toolbar {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.link-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
</style>

